 import {AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import { ContractService } from '../../lib/services/contracts/contract.service';
import {ClipboardService} from "ngx-clipboard"
import { StorageKeysEnum } from '../../lib/storage/storage-keys.enum';
import * as pubsub from 'pubsub-js';
import {PubsubEnum} from "../../lib/enums/pubsub.enum";
import { UserUtilsService } from '../../lib/services/user/user-utils.service';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { DashboardService } from '../../lib/services/dashboard/dashboard.service';
import { UserInfo } from '../../lib/models/user-info.model';
 import {environment} from "../../../environments/environment";

@Component({
  selector: 'lib-user-contracts-component',
  templateUrl: './user-contracts-component.component.html',
  styleUrls: ['./user-contracts-component.component.scss']
})
export class UserContractsComponentComponent implements OnInit, OnDestroy {
  @Input() contracts: any = [];
  contractSelected: any;
  clabeCopied = false;
  private routerSubscription: Subscription = new Subscription();
  isDashboardRoute: boolean = false;
  pictures: string[] = [
    `${environment.homeUrl}/assets/images/banner-monex.svg`,
    `${environment.homeUrl}/assets/images/banner-monex.svg`,
    `${environment.homeUrl}/assets/images/banner-monex.svg`,
  ]
  contractSubscription!: Subscription

  constructor(
    private contractService: ContractService,
    private clipboardApi: ClipboardService,
    private el: ElementRef,
    private userUtilsService: UserUtilsService,
    private router: Router,
    private dashboardService: DashboardService
    ) {
    }

    changeContract() {
      const userInfo = this.userUtilsService.getUserInfoSessionStorage()
      const newInfo = sessionStorage.setItem(StorageKeysEnum.USER_INFO, JSON.stringify({
        ...userInfo,
        contrato: this.contractSelected,
      }));
      this.dashboardService.updateContract(this.contractSelected)
      pubsub.publish("contract", this.contractSelected)
      pubsub.publish("renderingMenu", this.contractSelected)
    }

    ngOnInit(): void {
      const userInfo = this.userUtilsService.getUserInfoSessionStorage()
      this.contractSelected = Array.isArray(userInfo?.contrato) ? userInfo?.contrato[0] : userInfo.contrato;
      this.contractSubscription = this.dashboardService.contractEvent$.subscribe(value =>
        this.contractSelected = value
      )
      this.checkIfDashboardRoute()
      // this.checkIfDashboardRoute()
      this.routerSubscription = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.checkIfDashboardRoute()
      })
  }

  checkIfDashboardRoute() {
    this.isDashboardRoute = this.router.url.includes("dashboard")
  }

  copyClabe(clabe: any) {
    this.clabeCopied = this.clipboardApi.copyFromContent(clabe);
    setTimeout(() => {
      this.clabeCopied = false;
    }, 2000)
  }

  capitalizeWord(text: string){
    return text.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
  }

  ngOnDestroy(): void {
    this.contractSubscription.unsubscribe()
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe()
    }
  }
}
